module.exports = {
	"en": {
		"mainSections": [
			{
				"menu": {
					"id": 0,
					"name": "Intro",
					"url": ""
				},
				"mainSectionTitle": "100 Creative<br>Powers",
				"mainSectionExcerpt": "<p>Welcome to Victoria Dockside, the art and design district for culture, creativity and innovation, connecting global millennials to collide. This is the new face of the Hong Kong harbour-front.</p><p>Meet the 100 Creative Powers behind this cultural destination, who are inspiring new waves of disruption in architecture, art, culture, design and sustainability for tomorrow’s generation.</p>",
				"mainSectionIntro": "<p>Welcome to Victoria Dockside, the art and design district for culture, creativity and innovation, connecting global millennials to collide. This is the new face of the Hong Kong harbour-front.</p><p>Meet the 100 Creative Powers behind this cultural destination, who are inspiring new waves of disruption in architecture, art, culture, design and sustainability for tomorrow’s generation.</p>",
				"hasLink": true,
				"link": "enter",
				"externalUrl": "https://www.victoriadockside.com/100-creative-powers/en",
				"openExternal": true,
				"hasSubsection": false,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "enter",
				"videoSrc": {
					"desktop": "static/video/intro-compress27.mp4",
					"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Intro-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Intro-p-mobile.jpg"
				}
			},
			{
				"menu": {
					"id": 1,
					"name": "Heritage",
					"url": ""
				},
				"mainSectionTitle": "A history <br/> of making waves",
				"mainSectionExcerpt": "<p>Victoria Dockside is built on the site formerly known as Holt&rsquo;s Wharf. Founded in 1910, Holt&rsquo;s Wharf served as a global freight and logistics hub...</p>",
				"mainSectionIntro": "<p>Victoria Dockside is built on the site formerly known as Holt&rsquo;s Wharf. Founded in 1910, Holt&rsquo;s Wharf served as a global freight and logistics hub that helped establish Hong Kong as a gateway to the Far East and played a major role in the city becoming the busiest port in the world.</p><p>The location has a long history of transformation, being a game-changer in art, design, business and leisure.</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "read more",
				"videoSrc": {
					"desktop": "static/video/Heritage-fade-compress23.mp4",
					"mobile": "static/video/mobile/Heritage-mobile-fade_compressed-32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Heritage-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Heritage-p-mobile.jpg"
				},
				"subSection": [
					{
						"id": "1",
						"year": "1906",
						"title": "1906 First cross harbour race",
						"hasText": true,
						"text": "This was the starting point for what has become one of Hong Kong’s oldest traditions",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-01.jpg",
							"mobile": "static/bg-heritage-mobile-1.jpg",
							"alt": "1906 First cross harbour race"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"year": "1910",
						"title": "1910 Kowloon-Canton railway completed",
						"hasText": true,
						"text": "This was part of the first Hong Kong railway line to connect South China with the world",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-02.jpg",
							"mobile": "static/bg-heritage-mobile-2.jpg",
							"alt": "1910 Kowloon-Canton railway completed"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"year": "1980",
						"title": "1980 Hong Kong space museum opened",
						"hasText": true,
						"text": "This popular museum is where Hong Kong first reached out to the stars",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-04.jpg",
							"mobile": "static/bg-heritage-mobile-4.jpg",
							"alt": "1980 Hong Kong space museum opened"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"year": "1989",
						"title": "1989 Hong Kong cultural centre opened",
						"hasText": true,
						"text": "This harbour-front icon represents the cultural heart of Hong Kong",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-05.jpg",
							"mobile": "static/bg-heritage-mobile-5.jpg",
							"alt": "1989 Hong Kong cultural centre opened"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"year": "1991",
						"title": "1991 Hong Kong museum of art opened",
						"hasText": true,
						"text": "This is where Hong Kong exhibits and celebrates its most valued artistic treasures",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-06.jpg",
							"mobile": "static/bg-heritage-mobile-6.jpg",
							"alt": "1991 Hong Kong museum of art opened"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"year": "2003",
						"title": "2003 Avenue of stars",
						"hasText": true,
						"text": "This cultural landmark became Hong Kong’s most visited tourist attraction",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "right-to-left",
						"bgSrc": {
							"desktop": "static/bg-heritage-07.jpg",
							"mobile": "static/bg-heritage-mobile-7.jpg",
							"alt": "2003 Avenue of stars"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 2,
					"name": "Design",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in design",
				"mainSectionExcerpt": "<p>Located at the epicentre of Hong Kong, the Tsim Sha Tsui harbour-front, Victoria Dockside will set new precedents in architecture and will help transform the iconic Hong Kong skyline.</p>",
				"mainSectionIntro": "<p>Located at the epicentre of Hong Kong, the Tsim Sha Tsui harbour-front, Victoria Dockside will set new precedents in architecture and will help transform the iconic Hong Kong skyline.</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "read more",
				"videoSrc": {
					"desktop": "static/video/design-compress21.mp4",
					"mobile": "static/video/mobile/Design-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Design-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Design-p-mobile.jpg",
					"alt": "Victoria dockside Make waves in design"
				},
				"subSection": [
					{
						"id": "1",
						"title": "ARCHITECTURE BY<br/>KOHN PEDERSEN FOX ASSOCIATES",
						"hasText": true,
						"text": "<p>This new destination was designed by acclaimed New York-based Kohn Pedersen Fox Associates (KPF) - one of the world&rsquo;s largest architecture firms. Renowned for creating Roppongi Hills in Tokyo,<strong><em> </em></strong>KPF is creating a new aesthetic benchmark with the use of timeless materials.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-01.jpg",
							"mobile": "static/bg-design-mobile-01.jpg",
							"alt": "Victoria dockside ARCHITECTURE BY KOHN PEDERSEN FOX ASSOCIATES"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"title": "ARCHITECTURE BY<br/>KOHN PEDERSEN FOX ASSOCIATES",
						"hasText": true,
						"text": "<p>This new destination was designed by acclaimed New York-based Kohn Pedersen Fox Associates (KPF) - one of the world&rsquo;s largest architecture firms. Renowned for creating Roppongi Hills in Tokyo,<strong><em> </em></strong>KPF is creating a new aesthetic benchmark with the use of timeless materials.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-02.jpg",
							"mobile": "static/bg-design-mobile-02.jpg",
							"alt": "Victoria dockside ARCHITECTURE BY KOHN PEDERSEN FOX ASSOCIATES"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>Victoria Dockside will mark a turning point in the urban development of Hong Kong and a return to nature and greenery.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-07.jpg",
							"mobile": "static/bg-design-mobile-07.jpg",
							"alt": "Victoria dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>Victoria Dockside will mark a turning point in the urban development of Hong Kong and a return to nature and greenery.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-05.jpg",
							"mobile": "static/bg-design-mobile-05.jpg",
							"alt": "Victoria dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"title": "Landscape design by<br/>James Corner Field Operations",
						"hasText": true,
						"text": "<p>James Corner Field Operations creator of New York&rsquo;s iconic High Line concept has been enlisted to transform the harbour-front into an oasis of green spaces to provide the city, residents and visitors, inspiring new breathing space.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": "static/video/james-corner-desktop.mp4",
							"mobile": "static/video/james-corner-mobile.mp4"
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-03.jpg",
							"mobile": "static/bg-design-mobile-03.jpg",
							"alt": "Victoria dockside Landscape design by James Corner Field Operations"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"title": "Landscape design by<br/>James Corner Field Operations",
						"hasText": true,
						"text": "<p>James Corner Field Operations creator of New York&rsquo;s iconic High Line concept has been enlisted to transform the harbour-front into an oasis of green spaces to provide the city, residents and visitors, inspiring new breathing space.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-06.jpg",
							"mobile": "static/bg-design-mobile-06.jpg",
							"alt": "Victoria dockside Landscape design by James Corner Field Operations"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 3,
					"name": "Art",
					"url": ""
				},
				"mainSectionTitle": "Make waves <br class='hidden-xs'/>in art",
				"mainSectionExcerpt": "<p>Victoria Dockside provides a new creative heart for Hong Kong. A place where art, culture and craftsmanship is encouraged and amplified.</p>",
				"mainSectionIntro": "<p>Victoria Dockside provides a new creative heart for Hong Kong. A place where art, culture and craftsmanship is encouraged and amplified.</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": false,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "read more",
				"videoSrc": {
					"desktop": "static/video/art2-compress28.mp4",
					"mobile": "static/video/mobile/art2-mobile_compressed33.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Art-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Art-p-mobile.jpg",
					"alt": "Victoria dockside Make waves in art"
				}
			},
			{
				"menu": {
					"id": 4,
					"name": "Work Place",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in the work place",
				"mainSectionExcerpt": "",
				"mainSectionIntro": "",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"hasVideo": true,
				"button": "read more",
				"showDetailFront": false,
				"videoSrc": {
					"desktop": "static/video/workplace-compress30.mp4",
					"mobile": "static/video/mobile/Workplace-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Workplace-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Workplace-p-mobile.jpg",
					"alt": "Victoria dockside Make waves in the work place"
				},
				"subSection": [
					{
						"id": "1",
						"title": "",
						"hasText": true,
						"text": "<p>Victoria Dockside offers a new epicentre for game-changers in the world of business and innovation. Grade A office spaces combine the greatest new views of the city with versatile open plan design.</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-01.jpg",
							"mobile": "static/bg-work-mobile-1.jpg",
							"alt": "Victoria dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": false,
						"link": "Office site"
					},
					{
						"id": "2",
						"title": "",
						"hasText": true,
						"text": "",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-02.jpg",
							"mobile": "static/bg-work-mobile-2.jpg",
							"alt": "Victoria dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": true,
						"link": "K11 Atelier office site",
						"externalUrl": "https://www.k11atelier.com/"
					}
				]
			},
			{
				"menu": {
					"id": 5,
					"name": "Hospitality",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br class='hidden-xs'/> in hospitality",
				"mainSectionExcerpt": "<p>Rosewood Hotels &amp; Resorts&reg; is poised to unveil its latest premiere property on the Victoria Harbour waterfront at Victoria Dockside.</p>",
				"mainSectionIntro": "<p>Rosewood Hotels &amp; Resorts&reg; is poised to unveil its latest premiere property on the Victoria Harbour waterfront at Victoria Dockside.</p>",
				"hasLink": true,
				"link": "Rosewood Hong Kong",
				"hasSubsection": false,
				"showDetailFront": false,
				"openExternal": true,
				"externalUrl": "https://www.rosewoodhotels.com/en/hong-kong",
				"hasVideo": false,
				"button": "enter",
				"videoSrc": {
					"desktop": "static/video/Rosewood.mp4",
					"mobile": "static/video/Rosewood.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/Rosewood.jpg",
					"mobile": "static/rosewood_mobile.jpg",
					"alt": "Victoria dockside Make waves in hospitality"
				},
				"subSection": null
			}
		],
		"location": {
			"menu": {
				"id": 7,
				"name": "Location",
				"url": ""
			},
			"mainSectionTitle": "Location",
			"mainSectionExcerpt": "<p>Victoria Dockside is located at the epicentre Hong Kong, the Tsim Sha Tsui harbour-front.</p><p>18 Salisbury Road,<br/>Tsim Sha Tsui,<br/>Hong Kong</p>",
			"mainSectionIntro": "<p>Victoria Dockside is located at the epicentre Hong Kong, the Tsim Sha Tsui harbour-front.</p><p>18 Salisbury Road,<br/>Tsim Sha Tsui,<br/>Hong Kong</p>",
			"hasLink": true,
			"link": "Google Map",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "https://goo.gl/maps/D4sfhYNnxKx",
			"hasVideo": false,
			"button": "Enter",
			"videoSrc": {
				"desktop": "static/video/Intro8_compressed31-5.mp4",
				"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/vds_locationpage_en.jpg",
				"mobile": "static/vds_mobilemap_en_m.jpg",
				"alt": "Victoria dockside location"
			},
			"subSection": null
		},
		"event": {
			"menu": {
				"id": 8,
				"name": "Event",
				"url": ""
			},
			"mainSectionTitle": "Event",
			"mainSectionExcerpt": "<p>Discover what’s on at Victoria Dockside</p>",
			"mainSectionIntro": "<p>Discover what’s on at Victoria Dockside</p>",
			"hasLink": true,
			"link": "See Event",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "/event",
			"hasVideo": true,
			"button": "See Event",
			"videoSrc": {
				"desktop": "static/video/Event3-20.mp4",
				"mobile": "static/video/mobile/Event3_m_27.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/video/poster/event.jpg",
				"mobile": "static/video/mobile/poster/event-mobile.jpg",
				"alt": "Victoria dockside Event"
			},
			"subSection": null,
			"pageContent": {
				"title": "EVENT",
				"description": "text"
			}
		},
		"menu": [
			{
				"id": 0,
				"name": "Intro"
			},
			{
				"id": 999,
				"name": "100 Creative Powers"
			},
			{
				"id": 1,
				"name": "Heritage"
			},
			{
				"id": 2,
				"name": "Design"
			},
			{
				"id": 3,
				"name": "Art"
			},
			{
				"id": 4,
				"name": "Work Place"
			},
			{
				"id": 5,
				"name": "Hospitality"
			},
			{
				"id": 6,
				"name": "Press"
			},
			{
				"id": 7,
				"name": "Location"
			},
			{
				"id": 8,
				"name": "Event"
			}
		]
	},
	"tc": {
		"mainSections": [
			{
				"menu": {
					"id": 0,
					"name": "Intro",
					"url": ""
				},
				"mainSectionTitle": "100份<br>創意力量",
				"mainSectionExcerpt": "<p>歡迎來到Victoria Dockside，全球新世代將聚首於這個藝術、設計與文化新焦點，激發靈感創意，以創新思維迸發更多可能，重塑香港海濱的新風貌。</p><p>認識共同塑造這個文化新地標的一百份創意力量，他們為新世代的建築、藝術、文化、設計及可持續發展掀起新一波浪潮。</p>",
				"mainSectionIntro": "<p>歡迎來到Victoria Dockside，全球新世代將聚首於這個藝術、設計與文化新焦點，激發靈感創意，以創新思維迸發更多可能，重塑香港海濱的新風貌。</p><p>認識共同塑造這個文化新地標的一百份創意力量，他們為新世代的建築、藝術、文化、設計及可持續發展掀起新一波浪潮。</p>",
				"hasLink": true,
				"link": "進入",
				"hasSubsection": false,
				"externalUrl": "https://www.victoriadockside.com/100-creative-powers/tc",
				"showDetailFront": false,
				"openExternal": true,
				"hasVideo": true,
				"button": "進入",
				"videoSrc": {
					"desktop": "static/video/intro-compress27.mp4",
					"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Intro-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Intro-p-mobile.jpg",
					"alt": "認識為香港建構全新文化地標的100份創意力量"
				}
			},
			{
				"menu": {
					"id": 1,
					"name": "Heritage",
					"url": ""
				},
				"mainSectionTitle": "A history <br/> of making waves",
				"mainSectionExcerpt": "<p>Victoria Dockside前身為藍煙囪碼頭，於1910年代是環球航運及物流樞紐。</p>",
				"mainSectionIntro": "<p>Victoria Dockside前身為藍煙囪碼頭，於1910年代是環球航運及物流樞紐。作為通向遠東的大門，藍煙囪碼頭有助香港奠定國際上的地位，帶動香港成為全球最繁忙的港口。</p><p>源遠流長的地理優勢，造就藝術、文化、酒店服務及商界的破格演變。</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "閱讀更多",
				"videoSrc": {
					"desktop": "static/video/Heritage-fade-compress23.mp4",
					"mobile": "static/video/mobile/Heritage-mobile-fade_compressed-32.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Heritage-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Heritage-p-mobile.jpg",
					"alt": "Victoria Dockside A history of making waves"
				},
				"subSection": [
					{
						"id": "1",
						"year": "1906",
						"title": "1906 首屆維港渡海泳",
						"hasText": true,
						"text": "香港其中一項歷史最悠久的大型活動",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-01.jpg",
							"mobile": "static/bg-heritage-mobile-1.jpg",
							"alt": "Victoria Dockside 1906 首屆維港渡海泳"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"year": "1910",
						"title": "1910 九廣鐵路通車",
						"hasText": true,
						"text": "成功將香港與南中國接軌的起步點",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-02.jpg",
							"mobile": "static/bg-heritage-mobile-2.jpg",
							"alt": "Victoria Dockside 1910 九廣鐵路通車"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"year": "1980",
						"title": "1980 香港太空館啟用",
						"hasText": true,
						"text": "帶領香港人探索天際的重要基地",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-04.jpg",
							"mobile": "static/bg-heritage-mobile-4.jpg",
							"alt": "Victoria Dockside 1980 香港太空館啟用"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"year": "1989",
						"title": "1989 香港文化中心啟用",
						"hasText": true,
						"text": "代表中西文化精髓的臨海地標",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-05.jpg",
							"mobile": "static/bg-heritage-mobile-5.jpg",
							"alt": "Victoria Dockside 1989 香港文化中心啟用"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"year": "1991",
						"title": "1991 香港藝術館啟用",
						"hasText": true,
						"text": "珍藏及展示古今中外藝術的文化典堂",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-heritage-06.jpg",
							"mobile": "static/bg-heritage-mobile-6.jpg",
							"alt": "Victoria Dockside 1991 香港藝術館啟用"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"year": "2003",
						"title": "2003 星光大道開幕",
						"hasText": true,
						"text": "標誌著香港蜚聲國際文化產業的旅遊重點",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "right-to-left",
						"bgSrc": {
							"desktop": "static/bg-heritage-07.jpg",
							"mobile": "static/bg-heritage-mobile-7.jpg",
							"alt": "Victoria Dockside 2003 星光大道開幕"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 2,
					"name": "Design",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in design",
				"mainSectionExcerpt": "<p>貴為香港地區核心，屹立尖沙咀臨海地段，Victoria Dockside的前瞻性建築設計，令舉世知名的維港景觀耳目一新，繪寫匠心獨運的全新畫面。</p>",
				"mainSectionIntro": "<p>貴為香港地區核心，屹立尖沙咀臨海地段，Victoria Dockside的前瞻性建築設計，令舉世知名的維港景觀耳目一新，繪寫匠心獨運的全新畫面。</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "閱讀更多",
				"videoSrc": {
					"desktop": "static/video/design-compress21.mp4",
					"mobile": "static/video/mobile/Design-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Design-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Design-p-mobile.jpg",
					"alt": "Victoria Dockside Make waves in design"
				},
				"subSection": [
					{
						"id": "1",
						"title": "Kohn Pedersen Fox Associates建築策劃",
						"hasText": true,
						"text": "<p>新地標的設計藍圖，出自享負盛名的紐約建築事務所Kohn Pedersen Fox Associates (KPF) 。建築巨匠KPF曾一手創造東京「六本木新城」，憑藉劃時代的設計思維，為當代建築界樹立美學標準。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-01.jpg",
							"mobile": "static/bg-design-mobile-01.jpg",
							"alt": "Victoria Dockside Kohn Pedersen Fox Associates建築策劃"
						},
						"hasDetail": false
					},
					{
						"id": "2",
						"title": "Kohn Pedersen Fox Associates建築策劃",
						"hasText": true,
						"text": "<p>新地標的設計藍圖，出自享負盛名的紐約建築事務所Kohn Pedersen Fox Associates (KPF) 。建築巨匠KPF曾一手創造東京「六本木新城」，憑藉劃時代的設計思維，為當代建築界樹立美學標準。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-02.jpg",
							"mobile": "static/bg-design-mobile-02.jpg",
							"alt": "Victoria Dockside Kohn Pedersen Fox Associates建築策劃"
						},
						"hasDetail": false
					},
					{
						"id": "3",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>難得一見的綠化概念，於香港都心活現。Victoria Dockside率先領導市區發展，於建築群實現大規模綠化，為繁忙都心源源注氧。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-07.jpg",
							"mobile": "static/bg-design-mobile-07.jpg",
							"alt": "Victoria Dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "4",
						"title": "Make <br/>natural waves",
						"hasText": true,
						"text": "<p>難得一見的綠化概念，於香港都心活現。Victoria Dockside率先領導市區發展，於建築群實現大規模綠化，為繁忙都心源源注氧。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-05.jpg",
							"mobile": "static/bg-design-mobile-05.jpg",
							"alt": "Victoria Dockside Make natural waves"
						},
						"hasDetail": false
					},
					{
						"id": "5",
						"title": "James Corner Field Operations園境規劃",
						"hasText": true,
						"text": "<p>Victoria Dockside園境規劃設計師James Corner Field Operations (JCFO) ，成功創造紐約最具代表性的空中公園「High Line」，今日於香港揮灑創意，令維港海濱蛻變為綠化空間，為香港人及全球觀光客，開闢一片綠意天地。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": "static/video/james-corner-desktop.mp4",
							"mobile": "static/video/james-corner-mobile.mp4"
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-03.jpg",
							"mobile": "static/bg-design-mobile-03.jpg",
							"alt": "Victoria Dockside James Corner Field Operations園境規劃"
						},
						"hasDetail": false
					},
					{
						"id": "6",
						"title": "James Corner Field Operations園境規劃",
						"hasText": true,
						"text": "<p>Victoria Dockside園境規劃設計師James Corner Field Operations (JCFO) ，成功創造紐約最具代表性的空中公園「High Line」，今日於香港揮灑創意，令維港海濱蛻變為綠化空間，為香港人及全球觀光客，開闢一片綠意天地。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-design-06.jpg",
							"mobile": "static/bg-design-mobile-06.jpg",
							"alt": "Victoria Dockside James Corner Field Operations園境規劃"
						},
						"hasDetail": false
					}
				]
			},
			{
				"menu": {
					"id": 3,
					"name": "Art",
					"url": ""
				},
				"mainSectionTitle": "Make waves <br class='hidden-xs'/>in art",
				"mainSectionExcerpt": "<p>Victoria Dockside提供無邊無際的自由空間，讓藝術、設計、美藝及各個範疇的創意，於香港的核心大放異彩，造就世界級文化及創意地標。</p>",
				"mainSectionIntro": "<p>Victoria Dockside提供無邊無際的自由空間，讓藝術、設計、美藝及各個範疇的創意，於香港的核心大放異彩，造就世界級文化及創意地標。</p>",
				"hasLink": false,
				"link": null,
				"hasSubsection": false,
				"showDetailFront": false,
				"hasVideo": true,
				"button": "閱讀更多",
				"videoSrc": {
					"desktop": "static/video/art2-compress28.mp4",
					"mobile": "static/video/mobile/art2-mobile_compressed33.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Art-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Art-p-mobile.jpg",
					"alt": "Victoria Dockside Make waves in art"
				}
			},
			{
				"menu": {
					"id": 4,
					"name": "Work Place",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br/>in the work place",
				"mainSectionExcerpt": "",
				"mainSectionIntro": "",
				"hasLink": false,
				"link": null,
				"hasSubsection": true,
				"hasVideo": true,
				"button": "閱讀更多",
				"showDetailFront": false,
				"videoSrc": {
					"desktop": "static/video/workplace-compress30.mp4",
					"mobile": "static/video/mobile/Workplace-mobile_compressed30.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/video/poster/Workplace-p-desktop.jpg",
					"mobile": "static/video/mobile/poster/Workplace-p-mobile.jpg",
					"alt": "Victoria Dockside Make waves in the work place"
				},
				"subSection": [
					{
						"id": "1",
						"title": "",
						"hasText": true,
						"text": "<p>Victoria Dockside為敢於破格的商界及創科精英，重新界定現代化工作空間。甲級辦公大樓的智慧型設計，將壯闊維港景致納進開放式室內規劃，思維及概念無限激發。</p>",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-01.jpg",
							"mobile": "static/bg-work-mobile-1.jpg",
							"alt": "Victoria Dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": false,
						"link": "Office site"
					},
					{
						"id": "2",
						"title": "",
						"hasText": true,
						"text": "",
						"hasVideo": false,
						"videoSrc": {
							"desktop": null,
							"mobile": null
						},
						"pan": "left-to-right",
						"bgSrc": {
							"desktop": "static/bg-work-02.jpg",
							"mobile": "static/bg-work-mobile-2.jpg",
							"alt": "Victoria Dockside Make waves in the work place"
						},
						"hasDetail": false,
						"hasLink": true,
						"link": "K11 Atelier office site",
						"externalUrl": "https://www.k11atelier.com/"
					}
				]
			},
			{
				"menu": {
					"id": 5,
					"name": "Hospitality",
					"url": ""
				},
				"mainSectionTitle": "Make waves<br class='hidden-xs'/> in hospitality",
				"mainSectionExcerpt": "<p>世界級奢華品牌瑰麗酒店將於Victoria Dockside閃耀登場，將成為香港璀璨天際線的另一新地標。</p>",
				"mainSectionIntro": "<p>世界級奢華品牌瑰麗酒店將於Victoria Dockside閃耀登場，將成為香港璀璨天際線的另一新地標。</p>",
				"hasLink": true,
				"link": "Rosewood Hong Kong",
				"hasSubsection": false,
				"showDetailFront": false,
				"openExternal": true,
				"externalUrl": "https://www.rosewoodhotels.com/tc/hong-kong",
				"hasVideo": false,
				"button": "進入",
				"videoSrc": {
					"desktop": "static/video/Rosewood.mp4",
					"mobile": "static/video/Rosewood.mp4"
				},
				"pan": "left-to-right",
				"bgSrc": {
					"desktop": "static/Rosewood.jpg",
					"mobile": "static/rosewood_mobile.jpg",
					"alt": "Victoria Dockside Make waves in hospitality"
				},
				"subSection": null
			}
		],
		"location": {
			"menu": {
				"id": 7,
				"name": "Location",
				"url": ""
			},
			"mainSectionTitle": "Location",
			"mainSectionExcerpt": "<p>Victoria Dockside位處尖沙咀海濱。</p><p>香港九龍尖沙咀梳士巴利道18號</p>",
			"mainSectionIntro": "<p>Victoria Dockside位處尖沙咀海濱。</p><p>香港九龍尖沙咀梳士巴利道18號</p>",
			"hasLink": true,
			"link": "Google Map",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "https://goo.gl/maps/Cmk4CnJ37pC2",
			"hasVideo": false,
			"button": "進入",
			"videoSrc": {
				"desktop": "static/video/Intro8_compressed31-5.mp4",
				"mobile": "static/video/mobile/intro8-mobile_compressed32.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/vds_locationpage_cn.jpg",
				"mobile": "static/vds_locationpage_cn_m.jpg",
				"alt": "Victoria Dockside location"
			},
			"subSection": null
		},
		"event": {
			"menu": {
				"id": 8,
				"name": "Event",
				"url": ""
			},
			"mainSectionTitle": "Event",
			"mainSectionExcerpt": "<p>發掘更多在 Victoria Dockside 掀起的革新浪潮</p>",
			"mainSectionIntro": "<p>發掘更多在 Victoria Dockside 掀起的革新浪潮</p>",
			"hasLink": true,
			"link": "See Event",
			"hasSubsection": false,
			"showDetailFront": false,
			"openExternal": true,
			"externalUrl": "/tc/event",
			"hasVideo": true,
			"button": "See Event",
			"videoSrc": {
				"desktop": "static/video/Event3-20.mp4",
				"mobile": "static/video/mobile/Event3_m_27.mp4"
			},
			"pan": "left-to-right",
			"bgSrc": {
				"desktop": "static/video/poster/event.jpg",
				"mobile": "static/video/mobile/poster/event-mobile.jpg",
				"alt": "Victoria dockside Event"
			},
			"subSection": null,
			"pageContent": {
				"title": "EVENT",
				"description": "text"
			}
		},
		"menu": [
			{
				"id": 0,
				"name": "Intro"
			},
			{
				"id": 999,
				"name": "100 Creative Powers"
			},
			{
				"id": 1,
				"name": "Heritage"
			},
			{
				"id": 2,
				"name": "Design"
			},
			{
				"id": 3,
				"name": "Art"
			},
			{
				"id": 4,
				"name": "Work Place"
			},
			{
				"id": 5,
				"name": "Hospitality"
			},
			{
				"id": 6,
				"name": "Press"
			},
			{
				"id": 7,
				"name": "Location"
			},
			{
				"id": 8,
				"name": "Event"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/data.json
// module id = 468
// module chunks = 5